import React, { useState, useEffect } from 'react'
import DateTime from "react-datetime"
import Job from "./components/Job";
import Version from "./components/Version";
import Task from "./components/Task";
import Message from "./components/Message";
import { FormattedMessage, useIntl } from "react-intl";
import messages from "./messages";
import NiceModal, { useModal } from '@ebay/nice-modal-react'
import {
  Modal,
  Button
} from '@arnsbogroup/react-voicearchive'

export default NiceModal.create(({ orderId, action, refetch }) => {
  const modal = useModal()
  const { formatMessage } = useIntl()
  const [message, setMessage] = useState(action == 'hold'
    ? formatMessage(messages.defaultHoldMessage, {
      supplierFirstName: "{{supplier.firstname}}",
      coordinatorName: "{{coordinator.name}}",
      taskUrl: "{{taskUrl}}"
    })
    : formatMessage(messages.defaultResumeMessage, {
      supplierFirstName: "{{supplier.firstname}}",
      coordinatorName: "{{coordinator.name}}",
      taskUrl: "{{taskUrl}}"
    }));
  const [orderObject, setOrderObject] = useState({})
  const [onHoldTasks, setOnHoldTasks] = useState([])
  const [checkedTasks, setCheckedTasks] = useState([])
  const [deadline, setDeadline] = useState(new Date())

  useEffect(() => {
    fetch(`/rest/v1/order/${orderId}?includeRelations=1&includeTaskTree=1`)
      .then((response) => response.json())
      .then((order) => {
          setOrderObject(order)
          order.tasks.forEach(job => {
            job.versions.forEach(version => {
              setOnHoldTasks((prevHoldTasks) => {
                return prevHoldTasks.concat(version.tasks.filter((task) => parseInt(task.on_hold)))
              })
              setCheckedTasks((prevCheckedTasks) => {
                return prevCheckedTasks.concat(version.tasks.filter((task) => action == 'hold' ? parseInt(task.on_hold) && task.type.uid : !parseInt(task.on_hold) && task.type.uid))
              })
            });
          });
      })
      .catch((err) => {
        toastr.error(err) 
      })
  }, [])
  
  const unCheckTask = (unCheckedTask) => {
    let isTaskInOnHoldObject = checkedTasks.some(task => task.uid == unCheckedTask.uid);

    if (isTaskInOnHoldObject) {
      setCheckedTasks((prevCheckedTasks) => {
        return prevCheckedTasks.filter((task) => task.uid !== unCheckedTask.uid)
      })
    }
  }
  
  const checkTask = (checkedTask) => {
    let isTaskInOnHoldObject = checkedTasks.some(task => task.uid == checkedTask.uid);

    if (!isTaskInOnHoldObject) {
      setCheckedTasks((prevCheckedTasks) => {
        return [...prevCheckedTasks, checkedTask]
      })
    }
  }
  
  const checkAllVersionTasks = (version) => {
    let versionIsChecked = isVersionChecked(version);
    version.tasks.forEach(task => {
      if (!isTaskDisabled(task.uid)) {
        versionIsChecked ? unCheckTask(task) : checkTask(task)
      }
    });
  }
  
  const isVersionChecked = (version) => {
    return action === 'hold' ? 
      version.tasks.every(task => checkedTasks.some(el => el.uid == task.uid && el.on_hold)) :
      version.tasks.every(task => checkedTasks.some(el => el.uid == task.uid))
  }

  const isTaskDisabled = (taskId) => {
    return action === 'hold' ?
      onHoldTasks.some(el => el.uid == taskId && el.on_hold) :
      !onHoldTasks.some(el => el.uid == taskId && el.on_hold)
  }

  const onSave = () => {
    fetch(`/rest/v2/order/${orderId}/${action}Tasks`, {
      method: 'PUT',
      credentials: 'same-origin',
      body: JSON.stringify({
        tasks: checkedTasks,
        message: message,
        deadline: deadline
      }),
    })
    .then((response) => response.json())
    .then(({ success, error }) => {
      if (success) {
        toastr.success('Tasks updated')
        modal.resolve()
        modal.remove()
        refetch()
      } else {
        toastr.error(error)
      }
    })
    .catch((error) => {
      toastr.error(error)
    })
  }

  return (
    <Modal
      show={modal.visible}
      onClose={() => modal.remove()}
      onOutsideClick={() => modal.remove()}
      dialogPanelClasses="overflow-y-visible"
      title={formatMessage(action == 'hold' ? messages.holdHeading : messages.resumeHeading)}
    >
      <div className="w-full h-full flex flex-col">
        <div className='grow flow-root mx-8'>
          
          { orderObject.tasks && orderObject.tasks.map((job) => (
            <div
              key={job.uid}
              className={`hover:text-black`}
            >
              <Job job={job} />
              { job.versions && job.versions.map((version) => (
                <div
                  className='ml-4'
                  key={version.uid}
                >
                  <Version 
                  checkAllVersionTasks={checkAllVersionTasks}
                  disabled={action === 'hold' ? version.tasks.every(task => task.on_hold == 1) : version.tasks.every(task => task.on_hold == 0)} 
                  checked={isVersionChecked(version)}
                  version={version} />
                  { version.tasks && version.tasks.map((task) => (
                    <div className='ml-8'> 
                      <Task 
                        disabled={isTaskDisabled(task.uid)} 
                        checked={checkedTasks.some(el => el.uid === task.uid && el.on_hold)} 
                        changeCheckedTasks={checkedTasks.some(el => el.uid === task.uid && el.on_hold) ? unCheckTask : checkTask}
                        task={task} />
                    </div>
                  )) }
                </div>
              )) }
            </div>
          )) }
            <div className='mt-4'>
              <Message 
                heading={formatMessage(action == 'hold' ? messages.holdMessageHeading : messages.resumeMessageHeading)}
                description={formatMessage(action == 'hold' ? messages.holdMessageDescription : messages.resumeMessageDescription)}
                setMessage={setMessage}  
                value={message}   
              />
            </div>
            { action != 'hold' &&
              <div>
                <div>
                  <div className="mt-3">Deadline *</div>
                  <DateTime
                    value={deadline}
                    onChange={(value) => setDeadline(value)}
                    inputProps={{className: "h-9 mt-2 text-center rounded-sm w-1/2 border-t-gray-300 border"}}
                    closeOnTab
                    closeOnSelect
                  />
                </div>
              </div>
            }
        </div>
        <div className="flex items-center justify-end m-6">
          <Button 
            onClick={() => onSave()}
            icon={['fa', 'long-arrow-right']}
            iconPosition="right"
          >
            {action === 'hold' ? formatMessage(messages.holdButton) : formatMessage(messages.resumeButton)}
          </Button>
        </div>
      </div>
    </Modal>
  )
})
